import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { CardContentInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatCardContent } from '@angular/material/card';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';

@Component({
  selector: 'tb-card-content',
  imports: [DynamicWidgetDirective, AsyncPipe, ParsePipe, MatCardContent],
  template: `
    <mat-card-content [class]="input().styleClasses | parse: context() | async">
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </mat-card-content>
  `,
  styles: `
    tb-card-content {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class CardContentComponent extends WidgetInputBaseComponent<CardContentInput> {}
